/**
 * Sticky Header Implementation for Amazon Marketing Theme
 * 
 * This script ensures the header sticks to the top of the page when scrolling.
 */

document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.site-header');
  
  if (!header) return;
  
  // Check if sticky header is enabled
  const stickyEnabled = header.hasAttribute('data-sticky') && 
                       header.getAttribute('data-sticky') === 'true';
  
  if (!stickyEnabled) return;
  
  // Get header height
  const headerHeight = header.offsetHeight;
  
  // Create a placeholder to prevent content jump
  const headerPlaceholder = document.createElement('div');
  headerPlaceholder.style.height = headerHeight + 'px';
  headerPlaceholder.style.display = 'none';
  headerPlaceholder.id = 'header-placeholder';
  header.parentNode.insertBefore(headerPlaceholder, header);
  
  // Apply sticky styles directly
  function makeHeaderSticky() {
    header.style.position = 'fixed';
    header.style.top = '0';
    header.style.left = '0';
    header.style.right = '0';
    header.style.width = '100%';
    header.style.zIndex = '9999';
    header.style.backgroundColor = '#FFFFFF';
    header.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.1)';
    headerPlaceholder.style.display = 'block';
  }
  
  // Remove sticky styles
  function makeHeaderNormal() {
    header.style.position = '';
    header.style.top = '';
    header.style.left = '';
    header.style.right = '';
    header.style.width = '';
    header.style.zIndex = '';
    header.style.boxShadow = '';
    headerPlaceholder.style.display = 'none';
  }
  
  // Handle scroll events
  function handleScroll() {
    if (window.scrollY > 10) {
      makeHeaderSticky();
    } else {
      makeHeaderNormal();
    }
  }
  
  // Add scroll event listener
  window.addEventListener('scroll', handleScroll);
  
  // Initial check
  handleScroll();
});
